import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { GeneralService } from './services/general.service';
import { App } from '@capacitor/app';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { VoipNotificationService } from './services/voip-notification.service';
import { refreshSimIdentity, setCurrentRoute } from './core/logger';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private router: Router,
    private generalService: GeneralService,
    private screenOrientation: ScreenOrientation,
    private platform: Platform,
    private voipNotificationService: VoipNotificationService
  ) {
    this.initializeApp();
    if (Capacitor.isNativePlatform()) {
      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
    }
    this.generalService.initilizeAppDefaults();
    this.checkInitailSetup();

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => setCurrentRoute(e.urlAfterRedirects));

    App.addListener('resume', () => {
      console.log("app resume")
      refreshSimIdentity();
      if (this.generalService.conXDefaults.default_page) {
        this.router.navigate([
          `/${this.generalService.conXDefaults.default_page}`, this.generalService.conXDefaults.default_page == 'favourites' ? { isFav: true } : {}
        ]);
      }
    });
  }
  
  initializeApp() {
    this.platform.ready().then(() => {
      this.voipNotificationService.initialize();
    });
  }
  
  async checkInitailSetup() {
    const { value: visit } = await Preferences.get({
      key: 'initial-setup-visit-done-new',
    });

    console.log('TEST312 Initial setup visit value initial-setup-visit-done-new:', visit);
    console.log('TEST312 ConX Defaults:', this.generalService.conXDefaults);

    if (Object.keys(this.generalService.conXDefaults).length > 0) {
      console.log('TEST312 Navigating based on default page setting');
      if (
        visit &&
        visit === 'done' &&
        this.generalService.conXDefaults.default_page
      ) {
        console.log('TEST312 Default page:', this.generalService.conXDefaults.default_page),
        this.router.navigate([
          `/${this.generalService.conXDefaults.default_page}`, this.generalService.conXDefaults.default_page == 'favourites' ? { isFav: true } : {}
        ]);
      } else if (
        visit &&
        visit === 'done' &&
        !this.generalService.conXDefaults.default_page
      ) {
        console.log('TEST312 No default page set, navigating to home');
        this.router.navigate(['/home']);
      }
    } else {
      console.log('TEST312 No ConX defaults found');
      if (visit && visit === 'done') {
        console.log('TEST312 No defaults found, navigating to home');
        this.router.navigate(['/home']);
      }
    }
  }
}
